export default __webpack_public_path__ + "beta-maps-guides-migrate-basic-map-1200-86c5f95b72684cf9e2c04a7a8639de57.webp";